// extracted by mini-css-extract-plugin
export default {"banner":"Footer_banner__idf1n"};